<template>
  <div class="nv-section-box">
    <div class="section-title">
      {{ section.label }}
    </div>
    <div class="books-section">
      <div class="book-item" :key="index" v-for="(book, index) in books">
        <div class="top" v-if="index === 0">
          <div class="top-book">
            <NvBookCover :book="book" :show-name="false" />
          </div>
          <div class="book-info" @click="goBookDetail(book)">
            <div class="name">{{ book.name }}</div>
            <div class="desc lo">{{ book.description }}</div>
          </div>
        </div>
        <NvBookCover v-else :book="book" />
      </div>
    </div>
  </div>
</template>

<script>
import NvBookCover from "@/components/NvBookCover";
export default {
  components: {
    NvBookCover
  },
  props: {
    section: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    books() {
      if (this.section && this.section.detail) {
        return this.section.detail.slice(0, 4);
      }
      return [];
    }
  },
  methods: {
    goBookDetail(book) {
      this.$router.push({
        name: "content",
        query: { id: book.id, name: book.name, from: this.$route.meta.pageName }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nv-section-box {
  .section-title {
    padding: 16px;
    padding-bottom: 0;
    font-size: $fs-xl;
    font-weight: 500;
  }
  .books-section {
    display: flex;
    flex-wrap: wrap;
    padding: 16px;
    justify-content: space-between;
  }

  .book-item:not(:nth-child(1)) {
    width: 30%;
  }

  .book-item:nth-child(2),
  .book-item:nth-child(3) {
    padding-right: 1vw;
  }

  .top {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    .top-book {
      width: 30%;
    }
  }

  .book-info {
    margin-left: 11px;
    padding-top: 11px;
    width: 60%;
    .name {
      font-weight: 500;
    }

    .desc {
      padding-top: 8px;
      color: $fc-grey;
      line-height: 20px;
      font-size: $fs-xs;
    }
  }
}
</style>
